import { useContext, useEffect, useState, useRef } from "react"
import { AppContext } from "../App"
import { AiOutlineUser } from 'react-icons/ai';
import { callApi, getInlineLoader } from "../Helpers";
import {
	STR_AMOUNT_2,
	STR_AVAILABLE_HOTELS,
	STR_BACK,
	STR_CASH,
	STR_CHANGE_PHONE_NUMBER,
	STR_CONSULTATION_FEE_PAYMENTS,
	STR_CONTACT_US,
	STR_FLOAT,
	STR_INVALID_SERVICE_PROVIDER,
	STR_MENU_HOTELS,
	STR_NEARBY_AGENTS,
	STR_NO_AGENT_FOUND,
	STR_NO_RECORD,
	STR_NOTIFICATIONS,
	STR_PAYMENT_SETTINGS,
	STR_PERSONAL_SETTINGS,
	STR_RECENT_REQUESTS,
	STR_REQUEST_AMOUNT_LIMIT,
	STR_REQUEST_FLOAT,
	STR_REQUEST_FLOAT_CASH,
	STR_SELECT,
	STR_SELECT_2,
	STR_SELECT_REQUEST_TYPE,
	STR_SERVICE_PROVIDER,
	STR_SUBMIT,
	STR_SUBSCRIPTION_FEE_PAYMENTS,
	STR_SUCCESS,
	STR_UPDATE_PERSONAL_INFO,
	STR_UPDATE_USERNAME
} from "../Strings";
import { BsFillPersonLinesFill, BsPersonGear } from 'react-icons/bs';
import { MdCheckCircle, MdContactPage, MdInfoOutline, MdOutlinePayment, MdOutlinePayments, MdOutlinePhonelinkSetup, MdOutlineSupport, MdSupportAgent, MdTranslate } from 'react-icons/md';
import { CgProfile } from "react-icons/cg";
import login_bg from '../assets/login_bg.jpg';
import HomeMenu from "./HomeMenu";
import WelcomeSlider from '../ones/WelcomeSlider';
import EditAgentProfile from "./EditAgentProfile";
import OpSuccessWidget from "../ones/OpSuccessWidget";
import OneAgent from '../ones/OneAgent';

export default function View(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ready, setReady] = useState(false);
	const [loading, setLoading] = useState(false);

	const [requestType, setRequestType] = useState('cash');
	const [tillType, setTillType] = useState('');
	const [amount, setAmount] = useState(0);
	const [offerExchange, setOfferExchange] = useState('no');
	const [offerExchangeFrom, setOfferExchangeFrom] = useState('');
	const [opSuccessful, setOpSuccessful] = useState(false);

	async function init() {
		//run initializations here
		setReady(false);
		await Promise.all([
			appContext.getNearbyAgents(),
		])
		setReady(true);
	}

	


	useEffect(() => {
		init();
	}, [])

	useEffect(() => {
		appContext.setShowOverlayLoader(loading);

		return () => {
			appContext.setShowOverlayLoader(false);
		}
	}, [ loading ])


	if (ready) {
		if(appContext.isAgentProfileComplete) {
			return (
				<div
					style={{
						width: "100%",
						height: "100%",
						overflow: "scroll",
						paddingTop: "20px",
						paddingBottom: "calc(var(--topBarHeight) + 40px)",
					}}
					className="mNoScrollBar"
				>
					<div className="container">

						<div className="row">

							<div className="col-md-12">
								<h6
									className="mSectionTitle"
								>
									{STR_NEARBY_AGENTS[appContext.language]}
								</h6>
							</div>

							<div className="col-md-12">
								{
									(appContext.nearbyAgents && appContext.nearbyAgents.length > 0) ?
									appContext.nearbyAgents.map((item, i) => {
										return (
											<OneAgent key={i} data={item}/>
										)
									})
									:
									<h6>{STR_NO_RECORD[appContext.language]}</h6>
								}
							</div>

						</div>

					</div>


				</div>
			)
			
		} else {
			return <EditAgentProfile/>
		}
	} else {
		return (
			<div
				className="mSupportLoading"
				style={{
					width: "100%",
					height: "100%",
				}}
			>
				{getInlineLoader()}
			</div>
		);
	}


}